'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ByAuthorBlock = require('./components/ByAuthorBlock.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ByAuthorBlock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-by-author-block/lib/index.js
// module id = 517
// module chunks = 1